/** @format */
import angular from 'angular';

export const attainmentFilterModule = 'sis-components.attainment.attainmentFilter';

(function () {
    translateAttainmentState.$inject = ['$translate'];
    angular.module(attainmentFilterModule, ['pascalprecht.translate']).filter('translateAttainmentState', translateAttainmentState);

    function translateAttainmentState($translate) {
        return function (state) {
            var stateTranslations = {
                ATTAINED: 'PROFILE.ATTAINMENT.STATE.ATTAINED',
                INCLUDED: 'PROFILE.ATTAINMENT.STATE.INCLUDED',
                SUBSTITUTED: 'PROFILE.ATTAINMENT.STATE.SUBSTITUTED',
                FAILED: 'PROFILE.ATTAINMENT.STATE.FAILED',
            };
            return $translate.instant(stateTranslations[state]);
        };
    }
})();
